/**
 * Broadcast Constants
 * Constantes e configurações do módulo de broadcast
 */
import { Bell, Mail, Send } from 'lucide-react'

export const BROADCAST_TYPES = {
	push: { label: 'Notificação Push', icon: Bell, color: 'blue' },
	email: { label: 'E-mail', icon: Mail, color: 'green' },
	both: { label: 'Ambos', icon: Send, color: 'purple' },
}

export const BROADCAST_STATUS = {
	draft: { label: 'Rascunho', color: 'gray' },
	sending: { label: 'Enviando', color: 'blue' },
	sent: { label: 'Enviado', color: 'green' },
	partial: { label: 'Parcial', color: 'yellow' },
	failed: { label: 'Falhou', color: 'red' },
}

export const AUDIENCE_OPTIONS = [
	{ value: 'all', label: 'Todos os usuários' },
	{ value: 'club_owners', label: 'Donos de clube' },
	{ value: 'active', label: 'Usuários ativos (últimos 30 dias)' },
	{ value: 'inactive', label: 'Usuários inativos' },
	{ value: 'new', label: 'Novos usuários (últimos 7 dias)' },
	{ value: 'custom', label: 'Selecionar usuários específicos' },
]

export const TYPE_OPTIONS = [
	{ value: 'push', label: 'Apenas Notificação Push' },
	{ value: 'email', label: 'Apenas E-mail' },
	{ value: 'both', label: 'Push + E-mail (conteúdos separados)' },
]

export const INITIAL_FORM_STATE = {
	type: 'push',
	pushTitle: '',
	pushMessage: '',
	emailSubject: '',
	emailTitle: '',
	emailBody: '',
	targetAudience: 'all',
	customUserIds: [],
	filters: {},
}

export const INITIAL_RESEND_FORM = {
	targetAudience: 'all',
	customUserIds: [],
}

// Estilos CSS para renderização de Markdown
export const MARKDOWN_PREVIEW_STYLES = `
	.markdown-preview h1 { font-size: 1.5em; font-weight: bold; margin-bottom: 0.5em; }
	.markdown-preview h2 { font-size: 1.3em; font-weight: bold; margin-bottom: 0.5em; }
	.markdown-preview h3 { font-size: 1.1em; font-weight: bold; margin-bottom: 0.5em; }
	.markdown-preview p { margin-bottom: 0.75em; }
	.markdown-preview strong { font-weight: bold; }
	.markdown-preview em { font-style: italic; }
	.markdown-preview ul { list-style-type: disc; margin-left: 1.5em; margin-bottom: 0.75em; }
	.markdown-preview ol { list-style-type: decimal; margin-left: 1.5em; margin-bottom: 0.75em; }
	.markdown-preview li { margin-bottom: 0.25em; }
	.markdown-preview hr { border: none; border-top: 1px solid rgba(255,255,255,0.2); margin: 1em 0; }
	.markdown-preview blockquote { border-left: 3px solid rgba(255,255,255,0.3); padding-left: 1em; margin: 0.75em 0; opacity: 0.8; }
	.markdown-preview code { background: rgba(255,255,255,0.1); padding: 0.2em 0.4em; border-radius: 3px; font-family: monospace; }
	.markdown-preview pre { background: rgba(255,255,255,0.1); padding: 1em; border-radius: 6px; overflow-x: auto; margin-bottom: 0.75em; }
	.markdown-preview a { color: #60a5fa; text-decoration: underline; }
`
